var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 2.4375C0 1.43666 0.799665 0.625 1.78571 0.625H23.2143C24.202 0.625 25 1.43666 25 2.4375C25 3.44004 24.202 4.25 23.2143 4.25H1.78571C0.799665 4.25 0 3.44004 0 2.4375ZM0 11.5C0 10.4975 0.799665 9.6875 1.78571 9.6875H23.2143C24.202 9.6875 25 10.4975 25 11.5C25 12.5025 24.202 13.3125 23.2143 13.3125H1.78571C0.799665 13.3125 0 12.5025 0 11.5ZM23.2143 22.375H1.78571C0.799665 22.375 0 21.565 0 20.5625C0 19.56 0.799665 18.75 1.78571 18.75H23.2143C24.202 18.75 25 19.56 25 20.5625C25 21.565 24.202 22.375 23.2143 22.375Z","fill":"#1A7196"}));
}

Hamburger.defaultProps = {"width":"25","height":"23","viewBox":"0 0 25 23","fill":"none"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
